import React from 'react';
import simonImage from '../../assets/Partnerwithus/Simon.jpg';
import jenImage from '../../assets/Partnerwithus/Jen.jpg';
import '../../styles/PartnerWithUs.css';

const people = [
  {
    name: 'SIMON',
    image: simonImage,
    link: 'https://ijoinera.era.com.sg/register?refer=88776944',
  },
  {
    name: 'JEN',
    image: jenImage,
    link: 'https://ijoinera.era.com.sg/register?refer=81338483',
  },
];

function PartnerJoinSection() {
  return (
    <section className="partnerJoinFinal">
      <div className="joinGrid">
        {people.map((person, index) => (
          <div className="joinItem" key={index}>
            <div className="circleImageWrapper">
              <img src={person.image} alt={person.name} className="circleImage" />
            </div>
            <a
              href={person.link}
              target="_blank"
              rel="noopener noreferrer"
              className="joinButton"
            >
              Join {person.name} Now!
            </a>
          </div>
        ))}
      </div>
    </section>
  );
}

export default PartnerJoinSection;
